import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class EmailLinks extends BaseModel {
  constructor() {
    super(collection(db, 'email_links'))
  }
}
